import {
  CaretDownOutlined,
  FilterOutlined,
  InfoCircleOutlined,
  ProfileOutlined,
  RightOutlined,
} from "@ant-design/icons";
import {
  Badge,
  Button,
  Card,
  Col,
  DatePicker,
  Empty,
  Form,
  Image,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  Table,
  Tabs,
} from "antd";
import { WORKING_STATUS } from "app/modules/truck/_redux/constants";
import { SCALE_STATUS } from "app/modules/lego/_redux/constants";
import classNames from "classnames";
import { filterOption, useQuery } from "core/helpers";
import {
  find,
  get,
  has,
  join,
  map,
  orderBy,
  size,
  sortBy,
  sumBy,
  trim,
} from "lodash";
import dayjs from "dayjs";
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import services from "services";
import NoImagePlaceholderBlend from "../../../../../images/NoImagePlaceholderBlend.png";
import {
  DVR_STATUS_FOR_FILTER,
  FILTER_TAG_NAME,
  UNIT_TYPE,
} from "../../_redux/constants";
import { ProfileDevicesModal } from "../../components/profile-devices";
import { Link } from "react-router-dom";
import { DEVICE_STATUS } from "app/modules/printer/_redux/constants";
import { TASK_TYPE } from "app/modules/app/_redux/constants";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
const IMAGE_STYLE = {
  justifySelf: "center",
  width: "80%",
  height: "64px",
  objectFit: "cover",
  borderRadius: "0.3rem",
};
const TRACKER_INSTALL_STATUS = {
  NEW: {
    text: "Tạo mới",
    color: "#212529",
  },
  PENDING: {
    text: "Đã lắp chưa có biển số",
    color: "#ffc107",
  },
  WORKING: {
    text: "Đã lắp vào xe chạy",
    color: "#069255",
  },
};

const INCIDENT_STATUS = {
  0: {
    text: "Chưa xử lý",
    color: "#EB5757",
  },
  10: {
    text: "Đã tiếp nhận",
    color: "#bdbdbd",
  },
  20: {
    text: "Chờ xử lý",
    color: "#ffc107",
  },
  30: {
    text: "Hoàn thành",
    color: "#069255",
  },
  PENDING: {
    text: "Đã lắp chưa có biển số",
    color: "#ffc107",
  },
  WORKING: {
    text: "Đã lắp vào xe chạy",
    color: "#069255",
  },
};

const TASK_STATUS = {
  DOING: {
    text: "Chưa hoàn thành",
    color: "#ffc107",
  },
  PAST_DUE: {
    text: "Quá hạn",
    color: "#EB5757",
  },
  DONE: {
    text: "Hoàn thành",
    color: "#069255",
  },
};

const bHeaderStyle = {
  fontSize: 32,
  fontWeight: 500,
};
const CARD_STYLE = {
  borderRadius: "0.42rem",
  boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)",
};

const defaultActivityLogs = {
  device_maintain_summary: {
    checked_total: 0,
    checking_total: 0,
    past_due_total: 0,
  },
  device_quality_statistics: {
    percentage_active_time: 0,
    active_time: 0,
    percentage_employee: 0,
    employee: 0,
    percentage_incident_total: 0,
    incident_total: 0,
    percentage_maintain_due_total: 0,
    maintain_due_total: 0,
    percentage_offline_total: 0,
    offline_total: 0,
    percentage_online_total: 0,
    online_total: 0,
    percentage_power: 0,
    power: 0,
    percentage_un_daily_checked: 0,
    un_daily_checked: 0,
  },
  to_do_checklist_statistic: [],
};

function CapacitoringDataPage(props) {
  let navigate = useNavigate();
  const query = useQuery();
  const [activityLogs, setActivityLogs] = useState(defaultActivityLogs);
  const listStation = useSelector(
    (x) => x.app.listUserStartLvStationFromAdmcsm
  );
  const [offlineDeviceStatusStatistics, setOfflineDeviceStatusStatistics] =
    useState([]);
  const [devices, setDevices] = useState([]);
  const [childDeviceTypes, setChildDeviceTypes] = useState([]);
  const [overviewData, setOverviewData] = useState([]);
  const [checklistFilters, setChecklistFilters] = useState({});
  const [viewDeviceList, setViewDeviceList] = useState({
    show: false,
    type: "",
    title: "",
  });

  const [selectedStation, setSelectedStation] = useState(undefined);
  const [overviewFromDate, setOverviewFromDate] = useState();
  const [isShowOffline, setIsShowOffline] = useState(false);

  const viewDevices = (deviceType) => {
    let title = FILTER_TAG_NAME[deviceType];
    if (title) {
      title = `Danh sách thiết bị ${title}`;
    }
    services.GdmsService.getChildDeviceTypes({ device_type: deviceType }).then(
      (r) => {
        let data = get(r, "data", []);
        setChildDeviceTypes(data);
      }
    );
    setViewDeviceList({
      show: true,
      type: deviceType,
      title: title,
    });
  };

  const offlineRef = useRef(null);
  const [form] = Form.useForm();
  const [deviceForm] = Form.useForm();
  const [offlineDeviceForm] = Form.useForm();
  const [isFetching, setIsFetching] = useState(false);
  const [fetchingDevice, setFetchingDevice] = useState(false);

  const [tableData, setTableData] = useState({
    dataSource: [],
    total: 0,
  });

  const [tableConfig, setTableConfig] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
    },
  });

  const [tableDeviceData, setTableDeviceData] = useState({
    dataSource: [],
    total: 0,
  });

  const [tableDeviceConfig, setTableDeviceConfig] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
    },
  });

  const [tableOfflineDeviceData, setTableOfflineDeviceData] = useState({
    dataSource: [],
    total: 0,
  });

  const [tableOfflineDeviceConfig, setTableOfflineDeviceConfig] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
    },
  });

  const [profileModal, setProfileModal] = useState({
    visible: false,
    dataSource: null,
  });
  const [showFilter, setShowFilter] = useState({
    show: false,
    hasFilter: false,
  });
  // const [showFilterOffline, setShowFilterOffline] = useState({
  //   show: false,
  //   hasFilter: false,
  // });

  const getColumnsIndex = (index) =>
    (tableConfig.pagination.current - 1) * tableConfig.pagination.pageSize +
    index +
    1;

  const columns = [
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      width: 75,
      align: "center",
      render: (_, __, index) => getColumnsIndex(index),
    },
    {
      title: "Loại công việc",
      key: "task_type",
      dataIndex: "task_type",
      width: 300,
      render: (value, record) => {
        if (!checklistFilters.task_type) return "";
        let color = "#bdbdbd";
        if (value && TASK_TYPE[value]) {
          color = TASK_TYPE[value].color;
        }
        let taskType = find(
          checklistFilters.task_type,
          (x) => x.value === value
        );
        return taskType ? (
          <div>
            <Badge color={color} text={taskType.name} />
            {value === "INCIDENT" && (
              <span className="ml-2">
                {dayjs(record.created_time).format("DD/MM/YYYY HH:mm:ss")}
                {record.incident_id && (
                  <Link
                    className="ml-2"
                    to={`/system/admin/device-incidents?id=${
                      record.incident_id
                    }`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "underline" }}
                  >
                    Chi tiết
                  </Link>
                )}
              </span>
            )}
          </div>
        ) : (
          ""
        );
      },
    },
    {
      title: "Loại thiết bị",
      dataIndex: "device_name",
      render: (value, item) => {
        if (item["big_device_task"]) {
          let key = `${item["device_type"]}_${item["sub_device_type"]}}`;
          let subDeviceName = checklistFilters.subDeviceMap[key];
          return item?.device_id
            ? `${value} - ${subDeviceName} - ${item["device_id"]}`
            : value;
        } else {
          return item?.device_id
            ? `${value || "N/A"} - ${item["device_id"]}`
            : value;
        }
      },
    },
    {
      title: "Vị trí",
      dataIndex: "station_position",
      width: 250,
    },
    {
      title: "Mã tài sản",
      dataIndex: "asset_code",
      align: "center",
      width: 150,
      render: (value) => {
        return value ? (
          <Link
            to={`/device/profile/${value}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            {value}
          </Link>
        ) : (
          ""
        );
      },
    },
    {
      title: "Người thực hiện",
      dataIndex: "finished_by",
      align: "center",
      width: 150,
    },
    {
      title: "Thời gian hoàn thành",
      dataIndex: "finished_time",
      align: "center",
      width: 175,
      render: (value) => {
        return value ? dayjs(value).format("DD/MM/YYYY HH:mm") : "";
      },
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      width: 150,
      render: (value, item) => {
        if ("DOING" === value) {
          return (
            <Badge
              color="orange"
              text={`${checklistFilters?.task_status?.[value] || value}`}
            />
          );
        } else if ("DONE" === value || "CLOSED" === value) {
          return (
            <Badge
              color="green"
              text={`${checklistFilters?.task_status?.[value] || value}`}
            />
          );
        } else if ("PAST_DUE" === value) {
          return (
            <Badge
              color="#EB5757"
              text={`${checklistFilters?.task_status?.[value] || value} `}
            />
          );
        }
      },
    },
    {
      title: "Profile",
      align: "center",
      key: "profile",
      width: 75,
      render: (_, record) => {
        return (
          <ProfileOutlined
            style={{ color: "#00904A", cursor: "pointer" }}
            onClick={() => {
              setProfileModal((prev) => ({
                ...prev,
                visible: true,
                dataSource: record,
              }));
            }}
          />
        );
      },
    },
  ];

  const deviceColumns = [
    {
      dataIndex: "label",
      title: "Tên thiết bị",
      width: 375,
      render: (value, record) => {
        return (
          <div
            style={{ minHeight: 250 }}
            className="d-flex justify-content-center flex-column"
          >
            <div style={{ fontSize: 18, fontWeight: 500 }}>{value}</div>
            <div className="d-flex mt-4 align-items-center">
              <span style={{ width: 100 }}>Số lượng</span>
              <span
                className="flex-grow-1"
                style={{ fontSize: 18, fontWeight: 400 }}
              >
                {record.total}
              </span>
            </div>
            <div className="d-flex mt-4 align-items-center">
              <span style={{ width: 100 }}>Trạng thái</span>
              <span className="flex-grow-1 d-flex align-items-center">
                <svg
                  width="8"
                  height="8"
                  viewBox="0 0 8 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="4" cy="4" r="4" fill="#00904A" />
                </svg>
                <span
                  className="ml-2"
                  style={{ fontSize: 18, fontWeight: 400 }}
                >
                  Online ({record.online}/{record.total})
                </span>
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataIndex: "status",
      title: "Tình trạng sử dụng",
      width: 400,
      render: (value, record) => {
        return (
          <div>
            {map(record.details, (detail, index) => {
              return (
                <div
                  className="d-flex justify-content-between align-items-center mt-4"
                  key={index}
                >
                  <span>{detail.status}</span>
                  <span style={{ fontSize: 18, fontWeight: 400 }}>
                    {detail.count}
                  </span>
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      dataIndex: "warning",
      title: "Cảnh báo",
      width: 400,
      render: (value, record) => {
        return (
          <div>
            {map(record.warning_messages || [], (warning, index) => {
              return (
                <div className="d-flex align-items-center mt-4" key={index}>
                  <span className="mb-1">
                    <svg
                      width="16"
                      height="19"
                      viewBox="0 0 16 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.7364 4.93334C13.5922 4.84944 13.414 4.84944 13.2698 4.93334C12.7111 5.24328 12.082 5.404 11.4431 5.4C10.509 5.42066 9.60586 5.06516 8.93648 4.41334C8.16373 3.65694 7.11892 3.24363 6.03783 3.26669C5.16717 3.25916 4.31592 3.52394 3.60317 4.02403V3.8C3.60317 3.35819 3.24502 3 2.80317 3C2.36133 3 2.00317 3.35816 2.00317 3.8V18.2C2.00317 18.6418 2.36133 19 2.80317 19C3.24499 19 3.60317 18.6418 3.60317 18.2V11.2667C3.69155 11.2584 3.77573 11.2251 3.84583 11.1707C4.48027 10.7034 5.24998 10.4563 6.03783 10.4667C6.97364 10.4452 7.87879 10.8007 8.54982 11.4533C9.32111 12.2086 10.3639 12.6219 11.4432 12.6C12.2703 12.6096 13.0816 12.3729 13.7738 11.92C13.9219 11.8173 14.0082 11.6468 14.0032 11.4666V5.4C14.0049 5.20775 13.9029 5.02947 13.7364 4.93334Z"
                        fill="#EB5757"
                      />
                    </svg>
                  </span>

                  <span className="ml-2">
                    {warning.label} ({warning.not_complete_count}/
                    {warning.total})
                  </span>
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      dataIndex: "bug",
      title: "Thông tin lỗi",
      width: 400,
      render: (_value, record) => {
        return (
          <div>
            {map(record.incident_statistic || [], (incident, index) => {
              if (
                incident.status === null ||
                incident.status === undefined ||
                incident.status === ""
              )
                return "";
              let status = INCIDENT_STATUS[incident.status];
              if (status) {
                return (
                  <div className="d-flex align-items-center mt-4" key={index}>
                    <span>
                      <svg
                        width="8"
                        height="8"
                        viewBox="0 0 6 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="3.00342" cy="3" r="3" fill={status.color} />
                      </svg>
                    </span>
                    <span className="ml-2">
                      {status.text} ({incident.total || 0})
                    </span>
                  </div>
                );
              }
            })}
          </div>
        );
      },
    },
    {
      dataIndex: "checkDaily",
      title: "Kiểm tra hàng ngày",
      width: 400,
      render: (value, record) => {
        return (
          <div>
            {map(record.daily_statistic || [], (item, index) => {
              return (
                <div className="d-flex align-items-center mt-4" key={index}>
                  <span>
                    <svg
                      width="8"
                      height="8"
                      viewBox="0 0 6 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="3.00342" cy="3" r="3" fill="#808080" />
                    </svg>
                  </span>
                  <span className="ml-2">
                    {item.task_name} ({item.complete_count}/{item.total})
                  </span>
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      dataIndex: "date",
      title: "Lịch bảo trì",
      width: 400,
      render: (value, record) => {
        return (
          <div>
            {map(record.periodic_statistic || [], (item, index) => {
              return (
                <div className="d-flex align-items-center mt-4" key={index}>
                  <svg
                    width="6"
                    height="6"
                    viewBox="0 0 6 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="3.00342" cy="3" r="3" fill="#808080" />
                  </svg>

                  <span
                    className="ml-2"
                    style={{ fontSize: 14, fontWeight: 400 }}
                  >
                    {item.task_name}
                  </span>
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      dataIndex: "",
      title: "Thao tác",
      width: 125,
      align: "center",
      render: (value, record) => {
        return (
          <span>
            <Button
              onClick={() => viewDevices(record.device_type)}
              type="primary"
            >
              Xem
            </Button>
          </span>
        );
      },
    },
  ];

  const offlineDeviceColumns = [
    {
      key: "index",
      dataIndex: "index",
      title: "STT",
      align: "center",
      width: 50,
      render: (_, __, index) =>
        (tableOfflineDeviceConfig.pagination.current - 1) *
          tableOfflineDeviceConfig.pagination.pageSize +
        index +
        1,
    },
    {
      title: "Mã thiết bị",
      dataIndex: "device_id",
      align: "center",
    },
    {
      title: "Mã tài sản",
      dataIndex: "asset_code",
      align: "center",
    },
    {
      title: "Tên tài sản",
      dataIndex: "name",
      align: "center",
    },
    {
      title: "Loại thiết bị",
      dataIndex: "type_code",
      align: "center",
    },
    {
      title: "Thời gian online gần nhất",
      dataIndex: "last_time_online",
      align: "center",
    },
    {
      title: "Profile",
      align: "center",
      key: "profile",
      render: (_, record) => {
        return (
          <ProfileOutlined
            style={{ color: "#00904A", cursor: "pointer" }}
            onClick={() => {
              setProfileModal((prev) => ({
                ...prev,
                visible: true,
                dataSource: record,
              }));
            }}
          />
        );
      },
    },
  ];

  let expandedRowRender = (record) => {
    const columns_device = [
      {
        title: "Thành phần kiểm tra",
        dataIndex: "sub_device_alias_name",
        align: "center",
        render: (value, item) => {
          let key = `${item["device_type"]}_${value}`;
          return checklistFilters.subDeviceMap[key]
            ? checklistFilters.subDeviceMap[key]
            : "";
        },
      },
      {
        title: "Chi tiết công việc",
        dataIndex: "content",
        render: (text) => {
          return <div style={{ whiteSpace: "pre-line" }}>{text}</div>;
        },
      },
      {
        title: "Thời gian thực hiện",
        dataIndex: "time_spend",
        align: "center",
        render: (value, item) => {
          return <span>{`${value} ${UNIT_TYPE?.[item.time_unit] || ""}`}</span>;
        },
      },
      {
        title: "Trạng thái",
        dataIndex: "status",
        align: "center",
        render: (value) => {
          if ("FINISHED" !== value) {
            return (
              <p>
                <Badge
                  color="#f50"
                  text={`${
                    checklistFilters?.sub_task_status?.[value] || value
                  }`}
                />
              </p>
            );
          } else {
            return (
              <p>
                <Badge
                  color="green"
                  text={`${
                    checklistFilters?.sub_task_status?.[value] || value
                  }`}
                />
              </p>
            );
          }
        },
      },
      {
        title: "Ảnh/Video",
        dataIndex: "media_url",
        align: "center",
        render: (value) => {
          if (!value) return "";
          return value?.map((item) => (
            <Image
              key={item}
              style={IMAGE_STYLE}
              src={item || NoImagePlaceholderBlend}
              fallback={NoImagePlaceholderBlend}
              height={64}
              preview={item || false}
            />
          ));
        },
      },
    ];

    const sub_data = record?.maintain_subtasks || [];

    return (
      <Table
        bordered
        rowKey={"subtask_id"}
        columns={columns_device}
        dataSource={sub_data}
        pagination={false}
      />
    );
  };

  let legoColumns = [];
  let deviceRowRender = undefined;

  if (viewDeviceList.type === "CONVEYOR") {
    legoColumns = [
      {
        title: "Kho",
        dataIndex: "station_name",
        align: "center",
      },
      {
        title: "Vị trí",
        dataIndex: "station_position",
      },
      {
        title: "Mã thiết bị",
        dataIndex: "device_id",
      },
      {
        title: "Mã tài sản",
        dataIndex: "asset_code",
      },
      {
        title: "Tên thiết bị",
        dataIndex: "name",
      },

      {
        title: "Serial Number",
        dataIndex: "serial_number",
        render: (value, record) => {
          return record.type_properties?.serial_number;
        },
      },
      {
        title: "Nhà cung cấp",
        dataIndex: "supplier",
        render: (value, record) => {
          return record.type_properties?.supplier;
        },
      },
      {
        title: "Kích thước",
        dataIndex: "size",
        render: (value, record) => {
          return record.type_properties?.size;
        },
      },
      {
        title: "Loại belt",
        dataIndex: "belt_type",
        render: (value, record) => {
          return record.type_properties?.belt_type;
        },
      },
      {
        title: "Trạng thái",
        dataIndex: "status",
        render: (value, record) => {
          return record.type_properties?.status;
        },
      },
      {
        title: "Số ngày sử dụng",
        dataIndex: "used_days",
        render: (value, record) => {
          return record.type_properties?.used_days;
        },
      },
      {
        title: "Profile",
        align: "center",
        key: "profile",
        render: (_, record) => {
          return (
            <ProfileOutlined
              style={{ color: "#00904A", cursor: "pointer" }}
              onClick={() => {
                setProfileModal((prev) => ({
                  ...prev,
                  visible: true,
                  dataSource: record,
                }));
              }}
            />
          );
        },
      },
    ];
    deviceRowRender = undefined;
  } else if (viewDeviceList.type === "MODULE_SORTING") {
    legoColumns = [
      {
        title: "Kho",
        dataIndex: "station_name",
        align: "center",
      },
      {
        title: "Mã thiết bị",
        dataIndex: "device_id",
      },
      {
        title: "Mã tài sản",
        dataIndex: "asset_code",
      },
      {
        title: "Tên thiết bị",
        dataIndex: "name",
      },
      {
        title: "Mã xe",
        dataIndex: "code",
        render: (value, record) => {
          return record.type_properties?.code;
        },
      },
      {
        title: "Loại xe",
        dataIndex: "type",
        render: (value, record) => {
          return record.type_properties?.type;
        },
      },
      {
        title: "Kích thước",
        dataIndex: "size",
        render: (value, record) => {
          return record.type_properties?.size;
        },
      },
      {
        title: "Trạng thái",
        dataIndex: "status",
        render: (value, record) => {
          return record.type_properties?.status;
        },
      },
      {
        title: "Số ngày sử dụng",
        dataIndex: "total_use_day",
        render: (value, record) => {
          return record.type_properties?.total_use_day;
        },
      },
      {
        title: "Profile",
        align: "center",
        key: "profile",
        render: (_, record) => {
          return (
            <ProfileOutlined
              style={{ color: "#00904A", cursor: "pointer" }}
              onClick={() => {
                setProfileModal((prev) => ({
                  ...prev,
                  visible: true,
                  dataSource: record,
                }));
              }}
            />
          );
        },
      },
    ];
    deviceRowRender = (record) => {
      const columns_device = [
        {
          title: "Thiết bị con",
          dataIndex: "type_name",
          align: "center",
        },
        {
          title: "Mã thiết bị",
          dataIndex: "device_id",
          align: "center",
        },
        {
          title: "Mã tài sản",
          dataIndex: "asset_code",
          align: "center",
        },
        {
          title: "Tên thiết bị",
          dataIndex: "name",
          align: "center",
        },
        {
          title: "Thuộc tính",
          dataIndex: "sub_device_alias_name",
          align: "center",
          render: (value, record) => {
            return (
              <div>
                {map(record.properties, (prop) => {
                  return (
                    <div key={prop.desc}>
                      {prop.desc} : {prop.value}
                    </div>
                  );
                })}
              </div>
            );
          },
        },
        {
          title: "Trạng thái",
          dataIndex: "sub_device_alias_name",
          align: "center",
          render: (value, record) => {
            let status = find(record.status, (x) => x.key == "status");
            if (status) return status.value;
            return "";
          },
        },
        {
          title: "Profile",
          align: "center",
          key: "profile",
          render: (_, record) => {
            return (
              <ProfileOutlined
                style={{ color: "#00904A", cursor: "pointer" }}
                onClick={() => {
                  setProfileModal((prev) => ({
                    ...prev,
                    visible: true,
                    dataSource: record,
                  }));
                }}
              />
            );
          },
        },
      ];
      const sub_data = record?.child_devices || [];

      return (
        <Table
          bordered
          rowKey={"subtask_id"}
          columns={columns_device}
          dataSource={sub_data}
          pagination={false}
        />
      );
    };
  } else if (viewDeviceList.type === "SCALE") {
    legoColumns = [
      {
        title: "Kho",
        dataIndex: "station_name",
        align: "center",
      },
      {
        title: "Mã thiết bị",
        dataIndex: "device_id",
      },
      {
        title: "Mã tài sản",
        dataIndex: "asset_code",
      },
      {
        title: "Tên thiết bị",
        dataIndex: "name",
      },
      {
        title: "Địa chỉ mac",
        dataIndex: "mac",
        render: (value, record) => {
          return record.type_properties?.mac;
        },
      },
      {
        title: "Phiên bản",
        dataIndex: "type",
        render: (value, record) => {
          return record.type_properties?.type;
        },
      },
      {
        title: "Loại cân",
        dataIndex: "option",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.option;
        },
      },
      {
        title: "Đợt cân",
        dataIndex: "version",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.version;
        },
      },
      {
        title: "Mở / Khoá",
        dataIndex: "lock",
        align: "center",
        render: (value, record) => {
          let lock = record.type_properties?.lock;
          if (lock == null || lock == undefined) return "";
          return lock ? "Đang khoá" : "Đang mở";
        },
      },
      {
        title: "Số ngày sử dụng",
        dataIndex: "total_use_day",
        render: (value, record) => {
          return record.type_properties?.total_use_day;
        },
      },
      {
        title: "Trạng thái cân",
        dataIndex: "status",
        key: "status",
        align: "center",
        render: (value, record) => {
          let status = record.type_properties?.status;
          if (status) {
            return (
              <div className="d-flex align-items-center flex-column">
                <span
                  style={{
                    width: 16,
                    height: 16,
                    backgroundColor: SCALE_STATUS[status]?.color,
                    borderRadius: "100%",
                  }}
                />
                <span style={{ fontSize: 13 }}>
                  {SCALE_STATUS[status]?.label}
                </span>
              </div>
            );
          }
        },
      },
      {
        title: "Profile",
        align: "center",
        key: "profile",
        render: (value, record) => {
          return (
            <ProfileOutlined
              style={{ color: "#00904A", cursor: "pointer" }}
              onClick={() => {
                setProfileModal((prev) => ({
                  ...prev,
                  visible: true,
                  dataSource: record,
                }));
              }}
            />
          );
        },
      },
    ];
    deviceRowRender = (record) => {
      const columns_device = [
        {
          title: "Thiết bị con",
          dataIndex: "type_name",
          align: "center",
        },
        {
          title: "Mã thiết bị",
          dataIndex: "device_id",
          align: "center",
        },
        {
          title: "Mã tài sản",
          dataIndex: "asset_code",
          align: "center",
        },
        {
          title: "Tên thiết bị",
          dataIndex: "name",
          align: "center",
        },
        {
          title: "Thuộc tính",
          dataIndex: "sub_device_alias_name",
          align: "center",
          render: (value, record) => {
            return (
              <div>
                {map(record.properties, (prop) => {
                  return (
                    <div key={prop.desc}>
                      {prop.desc} : {prop.value}
                    </div>
                  );
                })}
              </div>
            );
          },
        },
        {
          title: "Trạng thái",
          dataIndex: "sub_device_alias_name",
          align: "center",
          render: (value, record) => {
            let status = find(record.status, (x) => x.key == "status");
            if (status) return status.value;
            return "";
          },
        },
        {
          title: "Profile",
          align: "center",
          key: "profile",
          render: (_, record) => {
            return (
              <ProfileOutlined
                style={{ color: "#00904A", cursor: "pointer" }}
                onClick={() => {
                  setProfileModal((prev) => ({
                    ...prev,
                    visible: true,
                    dataSource: record,
                  }));
                }}
              />
            );
          },
        },
      ];
      const sub_data = record?.child_devices || [];

      return (
        <Table
          bordered
          rowKey={"subtask_id"}
          columns={columns_device}
          dataSource={sub_data}
          pagination={false}
        />
      );
    };
  } else if (viewDeviceList.type === "CROSSBELT") {
    legoColumns = [
      {
        title: "Kho",
        dataIndex: "station_name",
        align: "center",
      },
      {
        title: "Mã thiết bị",
        dataIndex: "device_id",
      },
      {
        title: "Mã tài sản",
        dataIndex: "asset_code",
      },
      {
        title: "Loại thiết bị",
        dataIndex: "name",
        render: (value, record) => {
          return record.type_properties?.type;
        },
      },
      {
        title: "Tên thiết bị",
        dataIndex: "name",
      },
      {
        title: "Serial Number",
        dataIndex: "serial_number",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.serial_number;
        },
      },
      {
        title: "Nhà cung cấp",
        dataIndex: "supplier",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.supplier;
        },
      },
      {
        title: "Số ngày sử dụng",
        dataIndex: "total_use_day",
        render: (value, record) => {
          return record.type_properties?.total_use_day;
        },
      },
      {
        title: "Profile",
        align: "center",
        key: "profile",
        render: (_, record) => {
          return (
            <ProfileOutlined
              style={{ color: "#00904A", cursor: "pointer" }}
              onClick={() => {
                setProfileModal((prev) => ({
                  ...prev,
                  visible: true,
                  dataSource: record,
                }));
              }}
            />
          );
        },
      },
    ];
  } else if (viewDeviceList.type === "BOMBAY") {
    legoColumns = [
      {
        title: "Kho",
        dataIndex: "station_name",
        align: "center",
      },
      {
        title: "Mã thiết bị",
        dataIndex: "device_id",
      },
      {
        title: "Mã tài sản",
        dataIndex: "asset_code",
      },
      {
        title: "Loại thiết bị",
        dataIndex: "type_code",
      },
      {
        title: "Tên thiết bị",
        dataIndex: "name",
      },
      {
        title: "Serial Number",
        dataIndex: "serial_number",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.serial_number;
        },
      },
      {
        title: "Nhà cung cấp",
        dataIndex: "supplier",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.supplier;
        },
      },
      {
        title: "Số ngày sử dụng",
        dataIndex: "total_use_day",
        render: (value, record) => {
          return record.type_properties?.total_use_day;
        },
      },
      {
        title: "Profile",
        align: "center",
        key: "profile",
        render: (_, record) => {
          return (
            <InfoCircleOutlined
              style={{ color: "#00904A", cursor: "pointer" }}
              onClick={() => {
                setProfileModal((prev) => ({
                  ...prev,
                  visible: true,
                  dataSource: record,
                }));
              }}
            />
          );
        },
      },
    ];
  } else if (viewDeviceList.type === "TRACKER") {
    legoColumns = [
      {
        title: "Kho",
        dataIndex: "station_name",
        align: "center",
      },
      {
        title: "Mã thiết bị",
        dataIndex: "device_id",
      },
      {
        title: "Mã tài sản",
        dataIndex: "asset_code",
      },
      {
        title: "Tên thiết bị",
        dataIndex: "name",
      },
      {
        title: "Firmware version",
        dataIndex: "current_firmware_version",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.current_firmware_version;
        },
      },
      {
        title: "Version",
        dataIndex: "version",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.version;
        },
      },
      {
        title: "Hardware version",
        dataIndex: "hardware_version",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.hardware_version;
        },
      },
      {
        title: "Số sim",
        dataIndex: "sim_number",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.sim_number;
        },
      },
      {
        title: "Trạng thái lắp đặt",
        dataIndex: "install_status",
        align: "center",
        render: (value, record) => {
          if (
            record.type_properties?.install_status &&
            TRACKER_INSTALL_STATUS[record.type_properties.install_status]
          ) {
            return (
              <Badge
                color={
                  TRACKER_INSTALL_STATUS[record.type_properties.install_status]
                    .color
                }
                text={
                  TRACKER_INSTALL_STATUS[record.type_properties.install_status]
                    .text
                }
              />
            );
          }

          return "";
        },
      },
      {
        title: "Trạng thái",
        dataIndex: "status",
        align: "center",
        render: (value, record) => {
          if (
            record.type_properties?.status &&
            WORKING_STATUS[record.type_properties.status]
          ) {
            return (
              <Badge
                color={WORKING_STATUS[record.type_properties.status].color}
                text={WORKING_STATUS[record.type_properties.status].text}
              />
            );
          }

          return "";
        },
      },
      {
        title: "Profile",
        align: "center",
        key: "profile",
        render: (_, record) => {
          return (
            <ProfileOutlined
              style={{ color: "#00904A", cursor: "pointer" }}
              onClick={() => {
                setProfileModal((prev) => ({
                  ...prev,
                  visible: true,
                  dataSource: record,
                }));
              }}
            />
          );
        },
      },
    ];
  } else if (viewDeviceList.type === "CAMERA_STATION") {
    legoColumns = [
      {
        title: "Kho",
        dataIndex: "station_name",
        align: "center",
      },
      {
        title: "Mã thiết bị",
        dataIndex: "device_id",
      },
      {
        title: "Mã tài sản",
        dataIndex: "asset_code",
      },
      {
        title: "Tên thiết bị",
        dataIndex: "name",
      },
      {
        title: "Loại thiết bị",
        dataIndex: "type",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.type;
        },
      },
      {
        title: "Số kênh",
        dataIndex: "no_of_channel",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.no_of_channel;
        },
      },
      {
        title: "Sn",
        dataIndex: "sn",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.sn;
        },
      },
      {
        title: "MAC",
        dataIndex: "mac",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.mac;
        },
      },
      {
        title: "Trạng thái",
        dataIndex: "status",
        align: "center",
        render: (value, record) => {
          if (
            record.type_properties?.status &&
            DVR_STATUS_FOR_FILTER[record.type_properties.status]
          ) {
            return (
              <Badge
                color={
                  DVR_STATUS_FOR_FILTER[record.type_properties.status].color
                }
                text={DVR_STATUS_FOR_FILTER[record.type_properties.status].text}
              />
            );
          }

          return "";
        },
      },
      {
        title: "Profile",
        align: "center",
        key: "profile",
        render: (_, record) => {
          return (
            <ProfileOutlined
              style={{ color: "#00904A", cursor: "pointer" }}
              onClick={() => {
                setProfileModal((prev) => ({
                  ...prev,
                  visible: true,
                  dataSource: record,
                }));
              }}
            />
          );
        },
      },
    ];
  } else if (viewDeviceList.type === "PRINTER") {
    legoColumns = [
      {
        title: "Kho",
        dataIndex: "station_name",
        align: "center",
      },
      {
        title: "Mã thiết bị",
        dataIndex: "device_id",
      },
      {
        title: "Mã tài sản",
        dataIndex: "asset_code",
      },
      {
        title: "Tên thiết bị",
        dataIndex: "name",
      },
      {
        title: "Loại thiết bị",
        dataIndex: "type",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.type;
        },
      },
      {
        title: "IP",
        dataIndex: "ip",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.ip;
        },
      },
      {
        title: "MAC",
        dataIndex: "mac",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.mac;
        },
      },
      {
        title: "Số ngày sử dụng",
        dataIndex: "used_days",
        render: (value, record) => {
          return record.type_properties?.total_use_day;
        },
      },
      {
        title: "Trạng thái",
        dataIndex: "status",
        align: "center",
        render: (value, record) => {
          if (
            record.type_properties?.status &&
            DEVICE_STATUS[record.type_properties.status]
          ) {
            return (
              <Badge
                color={DEVICE_STATUS[record.type_properties.status].color}
                text={DEVICE_STATUS[record.type_properties.status].label}
              />
            );
          }

          return "";
        },
      },
      {
        title: "Profile",
        align: "center",
        key: "profile",
        render: (_, record) => {
          return (
            <InfoCircleOutlined
              style={{ color: "#00904A", cursor: "pointer" }}
              onClick={() => {
                setProfileModal((prev) => ({
                  ...prev,
                  visible: true,
                  dataSource: record,
                }));
              }}
            />
          );
        },
      },
    ];
  } else if (viewDeviceList.type === "CABINET") {
    legoColumns = [
      {
        title: "Kho",
        dataIndex: "station_name",
        align: "center",
      },
      {
        title: "Mã thiết bị",
        dataIndex: "device_id",
      },
      {
        title: "Mã tài sản",
        dataIndex: "asset_code",
      },
      {
        title: "Tên thiết bị",
        dataIndex: "name",
      },
      {
        title: "Địa chỉ",
        dataIndex: "address",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.address;
        },
      },
      {
        title: "Loại tủ",
        dataIndex: "type",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.type;
        },
      },
      {
        title: "Tọa độ",
        dataIndex: "location",
        render: (value, record) => {
          return record.type_properties?.location;
        },
      },
      {
        title: "Trạng thái",
        dataIndex: "status",
        align: "center",
        render: (value, record) => {
          if (
            record.type_properties?.status &&
            DEVICE_STATUS[record.type_properties.status]
          ) {
            return (
              <Badge
                color={DEVICE_STATUS[record.type_properties.status].color}
                text={DEVICE_STATUS[record.type_properties.status].label}
              />
            );
          }

          return "";
        },
      },
      {
        title: "Profile",
        align: "center",
        key: "profile",
        render: (_, record) => {
          return (
            <InfoCircleOutlined
              style={{ color: "#00904A", cursor: "pointer" }}
              onClick={() => {
                setProfileModal((prev) => ({
                  ...prev,
                  visible: true,
                  dataSource: record,
                }));
              }}
            />
          );
        },
      },
    ];
  } else if (viewDeviceList.type === "CAMERA_TRUCK") {
    legoColumns = [
      {
        title: "Kho",
        dataIndex: "station_name",
        align: "center",
      },
      {
        title: "Mã thiết bị",
        dataIndex: "device_id",
      },
      {
        title: "Mã tài sản",
        dataIndex: "asset_code",
      },
      {
        title: "Tên thiết bị",
        dataIndex: "name",
      },
      {
        title: "Nhà cung cấp",
        dataIndex: "address",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.supplier;
        },
      },
      {
        title: "Model",
        dataIndex: "type",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.model;
        },
      },
      {
        title: "Biển số xe",
        dataIndex: "location",
        render: (value, record) => {
          return record.type_properties?.license_plate;
        },
      },
      {
        title: "Vị trí lắp",
        dataIndex: "position",
        render: (value, record) => {
          return record.type_properties?.position;
        },
      },
      {
        title: "Trạng thái",
        dataIndex: "status",
        align: "center",
        render: (value, record) => {
          if (
            record.type_properties?.status &&
            DEVICE_STATUS[record.type_properties.status]
          ) {
            return (
              <Badge
                color={DEVICE_STATUS[record.type_properties.status].color}
                text={DEVICE_STATUS[record.type_properties.status].label}
              />
            );
          }

          return "";
        },
      },
      {
        title: "Profile",
        align: "center",
        key: "profile",
        render: (_, record) => {
          return (
            <InfoCircleOutlined
              style={{ color: "#00904A", cursor: "pointer" }}
              onClick={() => {
                setProfileModal((prev) => ({
                  ...prev,
                  visible: true,
                  dataSource: record,
                }));
              }}
            />
          );
        },
      },
    ];
  } else if (viewDeviceList.type === "WHEEL_SORTER") {
    legoColumns = [
      {
        title: "Kho",
        dataIndex: "station_name",
        align: "center",
      },
      {
        title: "Mã thiết bị",
        dataIndex: "device_id",
      },
      {
        title: "Mã tài sản",
        dataIndex: "asset_code",
      },
      {
        title: "Tên thiết bị",
        dataIndex: "name",
      },
      {
        title: "Vị trí",
        dataIndex: "station_position",
        align: "center",
      },
      {
        title: "Nhà cung cấp",
        dataIndex: "supplier",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.supplier;
        },
      },
      {
        title: "Serial Number",
        dataIndex: "serial_number",
        render: (value, record) => {
          return record.type_properties?.serial_number;
        },
      },
      {
        title: "Kích thước",
        dataIndex: "size",
        render: (value, record) => {
          return record.type_properties?.size;
        },
      },

      {
        title: "Profile",
        align: "center",
        key: "profile",
        render: (_, record) => {
          return (
            <ProfileOutlined
              style={{ color: "#00904A", cursor: "pointer" }}
              onClick={() => {
                setProfileModal((prev) => ({
                  ...prev,
                  visible: true,
                  dataSource: record,
                }));
              }}
            />
          );
        },
      },
    ];
  } else if (viewDeviceList.type === "TELESCOPIC") {
    legoColumns = [
      {
        title: "Kho",
        dataIndex: "station_name",
        align: "center",
      },
      {
        title: "Mã thiết bị",
        dataIndex: "device_id",
      },
      {
        title: "Mã tài sản",
        dataIndex: "asset_code",
      },
      {
        title: "Tên thiết bị",
        dataIndex: "name",
      },

      {
        title: "Nhà cung cấp",
        dataIndex: "supplier",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.supplier;
        },
      },
      {
        title: "Kích thước",
        dataIndex: "size",
        render: (value, record) => {
          return record.type_properties?.size;
        },
      },
      {
        title: "Loại belt",
        dataIndex: "station_position",
        align: "center",
        render: (value, record) => {
          return record.type_properties?.belt_type;
        },
      },
      {
        title: "Profile",
        align: "center",
        key: "profile",
        render: (_, record) => {
          return (
            <ProfileOutlined
              style={{ color: "#00904A", cursor: "pointer" }}
              onClick={() => {
                setProfileModal((prev) => ({
                  ...prev,
                  visible: true,
                  dataSource: record,
                }));
              }}
            />
          );
        },
      },
    ];
  } else if (viewDeviceList.type === "BARRIER") {
    legoColumns = [
      {
        title: "Kho",
        dataIndex: "station_name",
        align: "center",
      },
      {
        title: "Mã thiết bị",
        dataIndex: "device_id",
      },
      {
        title: "Mã tài sản",
        dataIndex: "asset_code",
      },
      {
        title: "Tên thiết bị",
        dataIndex: "name",
      },
      {
        title: "Profile",
        align: "center",
        key: "profile",
        render: (_, record) => {
          return (
            <ProfileOutlined
              style={{ color: "#00904A", cursor: "pointer" }}
              onClick={() => {
                setProfileModal((prev) => ({
                  ...prev,
                  visible: true,
                  dataSource: record,
                }));
              }}
            />
          );
        },
      },
    ];
  }

  const getIndex = (index) =>
    (tableDeviceConfig.pagination.current - 1) *
      tableDeviceConfig.pagination.pageSize +
    index +
    1;
  legoColumns.unshift({
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: 75,
    align: "center",
    render: (_, __, index) => getIndex(index),
  });

  // const onBrowseActivityStatistic = useCallback(
  //   () => {
  //     if (selectedStation) {
  //       services.GdmsService.getActivityStatistics({
  //         station_id: selectedStation.value,
  //       }).then((r) => {
  //         let isSuccess = get(r, "success");
  //         if (isSuccess) {
  //           setActivityLogs(r.data);
  //         } else {
  //           setActivityLogs(defaultActivityLogs);
  //         }
  //       });
  //       getCheckListFilters(selectedStation.value);
  //     }
  //   },
  //   [selectedStation]
  // );
  const onBrowseStatusOverview = useCallback(() => {
    if (selectedStation) {
      let from = dayjs()
        .add(-7, "day")
        .startOf("day")
        .format("DD/MM/YYYY HH:mm:ss");
      let to = dayjs().endOf("day").format("DD/MM/YYYY HH:mm:ss");
      services.GdmsService.getDeviceStatusOverview({
        station_id: selectedStation.value,
        from_date: from,
        to_date: to,
      }).then((r) => {
        let isSuccess = get(r, "success");
        let listDevice = get(r, "data", []);
        if (isSuccess) {
          // Gọi thêm api để lấy thông tin 4 cột sau
          var deviceTypes = map(listDevice, (x) => x.device_type);
          services.GdmsService.getDeviceMaintainStatistic({
            device_types: join(deviceTypes, ","),
            station_id: selectedStation.value,
            from_date: from,
            to_date: to,
          }).then((r) => {
            isSuccess = get(r, "success");
            let data = get(r, "data", []);
            if (isSuccess) {
              listDevice = map(listDevice, (device) => {
                let finded = find(
                  data,
                  (x) => x.device_type == device.device_type
                );
                if (finded) {
                  device = {
                    ...device,
                    warning_messages: finded.warning_messages,
                    incident_statistic: finded.incident_statistic,
                    periodic_statistic: finded.periodic_statistic,
                    daily_statistic: finded.daily_statistic,
                  };
                }

                return device;
              });
              setDevices(listDevice);
            } else {
              setDevices(listDevice);
            }
          });
        } else {
          setDevices(listDevice);
        }
      });
    }
  }, [selectedStation]);

  const onValuesChange = () => {
    setTableConfig((prev) => ({
      ...prev,
      pagination: { ...prev.pagination, current: 1 },
    }));
  };
  const onOfflineDeviceValuesChange = () => {
    setTableOfflineDeviceConfig((prev) => ({
      ...prev,
      pagination: { ...prev.pagination, current: 1 },
    }));
  };

  const onChangeTable = (pagination) => {
    setTableConfig((prev) => ({ ...prev, pagination }));
  };
  const onChangeDeviceTable = (pagination) => {
    setTableDeviceConfig((prev) => ({ ...prev, pagination }));
  };
  const onChangeOfflineDeviceTable = (pagination) => {
    setTableOfflineDeviceConfig((prev) => ({ ...prev, pagination }));
  };

  const onChangeStation = (value) => {
    setSelectedStation(value);
    if (value) {
      localStorage.setItem(`capacitoring-station`, value.value);
    }
  };

  const onDeviceTableExpand = (expanded, record) => {
    if (expanded && record.device_id) {
      services.GdmsService.getDeviceChild({
        device_id: record.device_id,
        station_id: selectedStation.value,
      }).then((r) => {
        let data = get(r, "data", []);
        setTableDeviceData((prev) => {
          let next = { ...prev };
          let item = find(
            next.dataSource,
            (x) => x.device_id === record.device_id
          );
          item.child_devices = data;
          return next;
        });
      });
    }
  };

  const getCheckListFilters = (stationId, task_type) => {
    return services.GdmsService.getChecklistFilters({
      station_id: stationId,
      task_type: task_type === "all" ? undefined : task_type,
    }).then((r) => {
      let isSuccess = get(r, "success");
      if (isSuccess) {
        let deviceTypes = r.data["device_types"];
        let subDeviceMap = {};
        for (let i = 0; i < deviceTypes.length; i++) {
          let deviceType = deviceTypes[i];
          let subDeviceTypes = deviceType["sub_devices"];
          for (let j = 0; j < subDeviceTypes?.length; j++) {
            let subDeviceType = subDeviceTypes[j];
            subDeviceMap[
              deviceType["device_type"] + "_" + subDeviceType["alias_name"]
            ] = subDeviceType["name"];
          }
        }
        setChecklistFilters({ ...r.data, subDeviceMap });
      } else {
        setActivityLogs([]);
      }
    });
  };

  // useEffect(
  //   () => đ{
  //     // onBrowseActivityStatistic();
  //     // let interval = setInterval(() => {
  //     //   onBrowseActivityStatistic();
  //     //   setTableConfig((prev) => ({
  //     //     ...prev,
  //     //     pagination: { ...prev.paginadđtion, current: 1 },
  //     //   }));
  //     // }, 10000);
  //     return () => {
  //       // clearInterval(interval);
  //     };
  //   },
  //   [onBrowseActivityStatistic]
  // );
  useEffect(() => {
    onBrowseStatusOverview();
    // let interval = setInterval(() => onBrowseStatusOverview(), 10000);
    return () => {
      // clearInterval(interval);
    };
  }, [onBrowseStatusOverview]);

  useEffect(() => {
    if (size(listStation) > 0) {
      const urlParams = new URLSearchParams(window.location.search);
      const stationId = urlParams.get("station_id");
      if (stationId) {
        let station = find(
          listStation,
          (x) => x.value && x.value.toString() == stationId
        );
        setSelectedStation(station);
      } else {
        let savedStationId = localStorage.getItem("capacitoring-station");
        if (savedStationId) {
          let station = find(
            listStation,
            (x) => x.value && x.value.toString() == savedStationId
          );
          setSelectedStation(station);
        }
      }
    }
  }, [listStation]);

  useEffect(() => {
    if (selectedStation != null) {
      form.setFieldValue("station_id", selectedStation.value);
      navigate(`/system/admin/dashboard-device?station_id=${selectedStation.value}`);

      setTimeout(() => {
        setTableConfig((prev) => ({
          ...prev,
          pagination: { ...prev.pagination, current: 1 },
        }));
      }, 200);
    }
  }, [navigate, form, selectedStation]);

  useEffect(() => {
    let station_id = form.getFieldValue("station_id");
    if (!station_id) return;
    setIsFetching(true);

    const getTasks = async () => {
      let params = {
        station_id: station_id,
        page: tableConfig.pagination.current - 1,
        size: tableConfig.pagination.pageSize,
        task_type: form.getFieldValue("task_type") || undefined,
        device_type: form.getFieldValue("device_type")?.toString() || undefined,
        device_id: form.getFieldValue("device_id")?.toString() || undefined,
        username: form.getFieldValue("username")?.toString() || undefined,
        status: form.getFieldValue("status") || undefined,
      };
      if (params.task_type === "all") params.task_type = undefined;
      if (params.status === "all") params.status = undefined;
      params.from = dayjs().startOf("day").format("DD/MM/YYYY");
      params.to = dayjs().endOf("day").format("DD/MM/YYYY");
      let res = await services.GdmsService.getTimeline({
        ...params,
        is_profile: true,
      });
      setIsFetching(false);
      const isSuccess = get(res, "success");
      let data = [];
      if (isSuccess) {
        data = get(res, "data", []);
      }
      let total = get(res, "total_elements", 0);
      setTableData((prev) => {
        let next = { ...prev };
        next.dataSource = data;
        next.total = total;
        return next;
      });
      if (
        params.task_type ||
        params.device_type ||
        params.device_id ||
        params.username ||
        params.status
      ) {
        setShowFilter((prev) => ({ ...prev, hasFilter: true }));
      } else {
        setShowFilter((prev) => ({ ...prev, hasFilter: false }));
      }
    };
    getCheckListFilters(station_id, form.getFieldValue("task_type")).finally(
      () => {
        getTasks();
      }
    );
  }, [form, tableConfig]);

  const searchDevice = () => {
    setTableDeviceConfig((prev) => {
      let next = {
        ...prev,
        pagination: {
          ...prev.pagination,
          current: 1,
        },
      };
      return next;
    });
  };

  useEffect(() => {
    if (viewDeviceList.show) {
      if (selectedStation.value) {
        setFetchingDevice(true);
        let params = {};
        params.device_type = viewDeviceList.type;
        if (viewDeviceList.type === "CONVEYOR") {
          params.device_id = deviceForm.getFieldValue("device_id")
            ? trim(deviceForm.getFieldValue("device_id"))
            : undefined;
          params.asset_code = deviceForm.getFieldValue("asset_code")
            ? trim(deviceForm.getFieldValue("asset_code"))
            : undefined;
          params.station_position = deviceForm.getFieldValue("station_position")
            ? trim(deviceForm.getFieldValue("station_position"))
            : undefined;
        } else if (viewDeviceList.type === "MODULE_SORTING") {
          params.device_id = deviceForm.getFieldValue("device_id")
            ? trim(deviceForm.getFieldValue("device_id"))
            : undefined;
          params.asset_code = deviceForm.getFieldValue("asset_code")
            ? trim(deviceForm.getFieldValue("asset_code"))
            : undefined;
        } else if (viewDeviceList.type === "TRACKER") {
          params.device_id = deviceForm.getFieldValue("device_id")
            ? trim(deviceForm.getFieldValue("device_id"))
            : undefined;
          params.asset_code = deviceForm.getFieldValue("asset_code")
            ? trim(deviceForm.getFieldValue("asset_code"))
            : undefined;
          params.status = deviceForm.getFieldValue("status")
            ? trim(deviceForm.getFieldValue("status"))
            : undefined;
        } else if (viewDeviceList.type === "CAMERA_STATION") {
          params.device_id = deviceForm.getFieldValue("device_id")
            ? trim(deviceForm.getFieldValue("device_id"))
            : undefined;
          params.asset_code = deviceForm.getFieldValue("asset_code")
            ? trim(deviceForm.getFieldValue("asset_code"))
            : undefined;
          params.status = deviceForm.getFieldValue("status")
            ? trim(deviceForm.getFieldValue("status"))
            : undefined;
        } else if (viewDeviceList.type === "PRINTER") {
          params.device_id = deviceForm.getFieldValue("device_id")
            ? trim(deviceForm.getFieldValue("device_id"))
            : undefined;
          params.asset_code = deviceForm.getFieldValue("asset_code")
            ? trim(deviceForm.getFieldValue("asset_code"))
            : undefined;
          params.status = deviceForm.getFieldValue("status")
            ? trim(deviceForm.getFieldValue("status"))
            : undefined;
        } else if (viewDeviceList.type === "CABINET") {
          params.device_id = deviceForm.getFieldValue("device_id")
            ? trim(deviceForm.getFieldValue("device_id"))
            : undefined;
          params.asset_code = deviceForm.getFieldValue("asset_code")
            ? trim(deviceForm.getFieldValue("asset_code"))
            : undefined;
          params.status = deviceForm.getFieldValue("status")
            ? trim(deviceForm.getFieldValue("status"))
            : undefined;
        } else if (viewDeviceList.type === "CAMERA_TRUCK") {
          params.device_id = deviceForm.getFieldValue("device_id")
            ? trim(deviceForm.getFieldValue("device_id"))
            : undefined;
          params.asset_code = deviceForm.getFieldValue("asset_code")
            ? trim(deviceForm.getFieldValue("asset_code"))
            : undefined;
          params.status = deviceForm.getFieldValue("status")
            ? trim(deviceForm.getFieldValue("status"))
            : undefined;
        } else if (viewDeviceList.type === "SCALE") {
          params.sub_device_type = deviceForm.getFieldValue("type")
            ? trim(deviceForm.getFieldValue("type"))
            : undefined;
          params.status = deviceForm.getFieldValue("scale_status")
            ? trim(deviceForm.getFieldValue("scale_status"))
            : undefined;
          params.device_id = deviceForm.getFieldValue("device_id")
            ? trim(deviceForm.getFieldValue("device_id"))
            : undefined;
          params.asset_code = deviceForm.getFieldValue("asset_code")
            ? trim(deviceForm.getFieldValue("asset_code"))
            : undefined;
        } else if (viewDeviceList.type === "CROSSBELT") {
          params.sub_device_type = deviceForm.getFieldValue("type")
            ? trim(deviceForm.getFieldValue("type"))
            : undefined;
          params.device_id = deviceForm.getFieldValue("device_id")
            ? trim(deviceForm.getFieldValue("device_id"))
            : undefined;
          params.asset_code = deviceForm.getFieldValue("asset_code")
            ? trim(deviceForm.getFieldValue("asset_code"))
            : undefined;
        } else if (viewDeviceList.type === "BOMBAY") {
          params.sub_device_type = deviceForm.getFieldValue("type")
            ? trim(deviceForm.getFieldValue("type"))
            : undefined;
          params.device_id = deviceForm.getFieldValue("device_id")
            ? trim(deviceForm.getFieldValue("device_id"))
            : undefined;
          params.asset_code = deviceForm.getFieldValue("asset_code")
            ? trim(deviceForm.getFieldValue("asset_code"))
            : undefined;
        } else if (viewDeviceList.type === "WHEEL_SORTER") {
          params.sub_device_type = deviceForm.getFieldValue("type_code")
            ? trim(deviceForm.getFieldValue("type_code"))
            : undefined;
          params.device_id = deviceForm.getFieldValue("device_id")
            ? trim(deviceForm.getFieldValue("device_id"))
            : undefined;
          params.asset_code = deviceForm.getFieldValue("asset_code")
            ? trim(deviceForm.getFieldValue("asset_code"))
            : undefined;
          params.station_position = deviceForm.getFieldValue("station_position")
            ? trim(deviceForm.getFieldValue("station_position"))
            : undefined;
        } else if (viewDeviceList.type === "TELESCOPIC") {
          params.device_id = deviceForm.getFieldValue("device_id")
            ? trim(deviceForm.getFieldValue("device_id"))
            : undefined;
          params.asset_code = deviceForm.getFieldValue("asset_code")
            ? trim(deviceForm.getFieldValue("asset_code"))
            : undefined;
        } else if (viewDeviceList.type === "BARRIER") {
          params.device_id = deviceForm.getFieldValue("device_id")
            ? trim(deviceForm.getFieldValue("device_id"))
            : undefined;
          params.asset_code = deviceForm.getFieldValue("asset_code")
            ? trim(deviceForm.getFieldValue("asset_code"))
            : undefined;
        }
        params = {
          page: tableDeviceConfig.pagination.current - 1,
          size: tableDeviceConfig.pagination.pageSize,
          station_id: selectedStation.value,
          ...params,
        };
        services.GdmsService.getDeviceDataTypes(params)
          .then((r) => {
            let isSuccess = get(r, "success");
            let data = [];
            if (isSuccess) {
              data = get(r, "data", []);
            }
            let total = get(r, "total_elements", 0);
            setTableDeviceData((prev) => {
              let next = { ...prev };
              next.dataSource = data;
              next.total = total;
              return next;
            });
          })
          .finally(() => {
            setFetchingDevice(false);
          });
      }
    }
  }, [tableDeviceConfig, deviceForm, viewDeviceList, selectedStation]);

  const onCancelDeviceModal = () => {
    setViewDeviceList({ show: false });
    setTableDeviceData({
      dataSource: [],
      total: 0,
    });
    setTableDeviceConfig({
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
      },
    });
  };

  const onShowFilter = () => {
    setShowFilter((prev) => ({ ...prev, show: !prev.show }));
  };

  const renderFilterTag = () => {
    let renderDeviceType = null;
    let renderDeviceStatus = null;
    if (
      checklistFilters &&
      checklistFilters.task_type &&
      size(checklistFilters.task_type) > 0
    ) {
      let total = sumBy(checklistFilters.task_type, (x) => x.total);
      renderDeviceType = (
        <Form.Item name="task_type" className="mb-0">
          <Radio.Group name="task_type" optionType="button" buttonStyle="solid">
            <Radio.Button key="all" value="all">
              <span className="mt-1">{"Tất cả " + `(${total || 0})`}</span>
            </Radio.Button>
            {map(checklistFilters.task_type, (type) => {
              return (
                <Radio.Button key={type.name} value={type.value}>
                  <span className="mt-1">
                    {type.name + ` (${type.total || 0})`}
                  </span>
                </Radio.Button>
              );
            })}
          </Radio.Group>
        </Form.Item>
      );
    }
    if (
      checklistFilters &&
      checklistFilters.status_data &&
      size(checklistFilters.status_data) > 0
    ) {
      let activeFilterStyle = { borderColor: "#209e63" };
      let total = sumBy(checklistFilters.status_data, (x) => x.total);
      let taskStatus = form.getFieldValue("status");
      renderDeviceStatus = (
        <Form.Item name="status" className="mt-1 mb-0">
          <Space wrap>
            <Button
              style={taskStatus === "all" ? activeFilterStyle : {}}
              shape="round"
              onClick={() => {
                form.setFieldsValue({ status: undefined });
                onValuesChange();
              }}
            >
              <Badge
                color="#87d068"
                text={
                  <span className="mt-1">{"Tất cả " + `(${total || 0})`}</span>
                }
              />
            </Button>
            {map(checklistFilters.status_data, (type) => {
              let color = "#bdbdbd";
              if (type.name && TASK_STATUS[type.name]) {
                color = TASK_STATUS[type.name].color;
              }
              return (
                <Button
                  key={type.name}
                  style={taskStatus === type.name ? activeFilterStyle : {}}
                  shape="round"
                  onClick={() => {
                    form.setFieldsValue({ status: type.name });
                    onValuesChange();
                  }}
                >
                  <Badge
                    color={color}
                    text={
                      <span className="mt-1">
                        {type.value + ` (${type.total || 0})`}
                      </span>
                    }
                  />
                </Button>
              );
            })}
            <Button
              shape="round"
              style={isShowOffline ? activeFilterStyle : {}}
              onClick={() => {
                setIsShowOffline((prev) => !prev);
              }}
            >
              <Badge color="#EB5757" text="Xem thiết bị Offline" />
            </Button>
          </Space>
        </Form.Item>
      );
    }
    return (
      <div className="d-flex flex-column">
        {renderDeviceType}
        {renderDeviceStatus}
      </div>
    );
  };

  const renderFilterOfflineDeviceTag = () => {
    let renderDeviceStatus = null;

    if (size(offlineDeviceStatusStatistics) > 0) {
      let activeFilterStyle = { borderColor: "#209e63" };
      let deviceType = offlineDeviceForm.getFieldValue("device_type");
      console.log(deviceType);
      renderDeviceStatus = (
        <Form.Item name="status" className="mt-1 mb-0">
          <Space wrap>
            {map(offlineDeviceStatusStatistics, (type) => {
              return (
                <Button
                  style={
                    deviceType === type.device_type_id ? activeFilterStyle : {}
                  }
                  shape="round"
                  onClick={() => {
                    offlineDeviceForm.setFieldsValue({
                      device_type: type.device_type_id,
                    });
                    onOfflineDeviceValuesChange();
                  }}
                >
                  <Badge
                    color="#EB5757"
                    text={
                      <span className="mt-1">
                        {type.tag + ` (${type.total || 0})`}
                      </span>
                    }
                  />
                </Button>
              );
            })}
          </Space>
        </Form.Item>
      );
    }
    return <div className="d-flex flex-column">{renderDeviceStatus}</div>;
  };

  useLayoutEffect(() => {
    if (isShowOffline && selectedStation) {
      services.GdmsService.getDeviceOfflineStatistic({
        station_id: selectedStation.value,
      }).then((r) => {
        let data = get(r, "data", []);
        setOfflineDeviceStatusStatistics(
          [data[0]].concat(orderBy(data.slice(1), "tag"))
        );
      });
      let deviceType = offlineDeviceForm.getFieldValue("device_type");
      if (deviceType === null) deviceType = undefined;
      services.GdmsService.getDeviceStatus({
        page: tableOfflineDeviceConfig.pagination.current - 1,
        size: tableOfflineDeviceConfig.pagination.pageSize,
        station_id: selectedStation.value,
        device_type: deviceType,
        status: "OFFLINE",
      }).then((r) => {
        let isSuccess = get(r, "success");
        let data = [];
        if (isSuccess) {
          data = get(r, "data", []);
        }
        let total = get(r, "total_elements", 0);
        setTableOfflineDeviceData((prev) => {
          let next = { ...prev };
          next.dataSource = data;
          next.total = total;
          return next;
        });
        setTimeout(() => {
          if (offlineRef.current) {
            offlineRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }, 300);
      });
    }
  }, [
    isShowOffline,
    selectedStation,
    offlineDeviceForm,
    tableOfflineDeviceConfig,
  ]);

  let isHasSubTask = false;
  if (size(tableData.dataSource) > 0) {
    let anySubTask = find(
      tableData.dataSource,
      (x) => size(x.maintain_subtasks) > 0
    );
    if (anySubTask) isHasSubTask = true;
  }

  const data = {
    device_type: "MODULE_SORTING",
    device_type_name: "Put to light",
    done_maintenance_task: 1,
    unfinished_maintenance_task: 16,
    done_incident_task: 1,
    unfinished_incident_task: 36,
  };

  const onUpdateCmms = useCallback((selectedStation, overviewFromDate) => {
    if (!selectedStation) {
      return;
    }
    let params = {
      station_id: selectedStation.value,
    };
    if (overviewFromDate) {
      params.from = overviewFromDate.format("YYYY-MM-DD HH:mm:ss");
    }
    services.GdmsService.getCmmmsTaskOverview(params).then((r) => {
      let datasource = sortBy(get(r, "data", []), (x) => x.device_type_name);
      setOverviewData(
        map(datasource, (data) => {
          return {
            payload: data,
            chartData: {
              chart: {
                type: "column",
                style: {
                  fontFamily: "Roboto", // Áp dụng font Roboto cho toàn bộ chart
                },
              },
              title: {
                text: `${data.device_type_name}`,
                style: {
                  fontFamily: "Roboto",
                  fontSize: "16px", // Kích thước tùy chỉnh
                },
              },
              xAxis: {
                categories: ["Việc bảo trì", "Incident"],
                align: "center", // Căn giữa các nhãn

                style: {
                  fontFamily: "Roboto",
                  fontSize: "14px",
                },
              },
              yAxis: {
                min: 0,
                title: {
                  text: "",
                },
                labels: {
                  style: {
                    fontFamily: "Roboto",
                    fontSize: "14px",
                  },
                },
                stackLabels: {
                  enabled: false,
                  style: {
                    fontWeight: "bold",
                  },
                },
              },
              // Ẩn stackLabels để không hiển thị tổng cộng trên cột

              legend: {
                align: "center",
                verticalAlign: "bottom",
                layout: "horizontal",
                backgroundColor:
                  Highcharts.defaultOptions.legend.backgroundColor || "white",
                borderColor: "#069255",
                borderRadius: 5,
                borderWidth: 1,
                shadow: true,
                itemStyle: {
                  fontFamily: "Roboto",
                  fontSize: "14px",
                },
              },
              tooltip: {
                headerFormat: "<b>{point.x}</b><br/>",
                pointFormat:
                  "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
              },
              plotOptions: {
                column: {
                  stacking: "percent",
                  pointWidth: 90,
                  style: {
                    fontFamily: "Roboto",
                    fontSize: "12px",
                  },
                  dataLabels: {
                    enabled: true,
                    formatter: function () {
                      return this.percentage > 0
                        ? `${this.series.name} ${this.percentage.toFixed(1)}%`
                        : null;
                    },
                  },
                },
              },
              series: [
                {
                  name: "WOo",
                  data: [data.unfinished_maintenance_task, 0], // chỉ có giá trị ở cột "Maintenance"
                  stack: "maintenance", // stack chung cho Maintenance
                  color: "#B1F8CA",
                },
                {
                  name: "WOd",
                  data: [data.done_maintenance_task, 0], // chỉ có giá trị ở cột "Maintenance"
                  stack: "maintenance", // stack chung cho Maintenance
                  color: "#1AE259",
                },
                {
                  name: "Io",
                  data: [0, data.unfinished_incident_task], // chỉ có giá trị ở cột "Incident"
                  stack: "incident", // stack chung cho Incident
                  color: "#FEB1B1",
                },
                {
                  name: "Id",
                  data: [0, data.done_incident_task], // chỉ có giá trị ở cột "Incident"
                  stack: "incident", // stack chung cho Incident
                  color: "#FE6D6D",
                },
              ],
              credits: {
                enabled: false, // Ẩn "highcharts.com"
              },
              exporting: {
                enabled: false, // Tắt nút hành động
              },
            },
          };
        })
      );
    });
  }, []);

  useEffect(() => {
    onUpdateCmms(selectedStation, overviewFromDate);
  }, [selectedStation, overviewFromDate]);

  const onRefresh = () => {
    onUpdateCmms(selectedStation, overviewFromDate);
  };

  return (
    <Card
      size="small"
      className="dashboard-device__page"
      style={CARD_STYLE}
      headStyle={{
        borderBottom: "2px solid #E8E8E8",
        padding: "0 16px",
        fontSize: 32,
      }}
      bodyStyle={{ padding: 0, background: "#f8f8f8" }}
      title={<span style={{ fontSize: 32 }}>Quản lý thiết bị</span>}
      extra={
        <Select
          style={{ minWidth: 300 }}
          filterOption={(inputValue, option) =>
            filterOption(inputValue, option.label)
          }
          value={selectedStation}
          placeholder="Chọn kho"
          allowClear
          onChange={onChangeStation}
          labelInValue
          showSearch
          options={listStation}
        />
      }
    >
      {selectedStation ? (
        <Tabs
          // defaultActiveKey="Device"
          tabBarStyle={{
            background: "#fff",
            padding: "0px 16px",
            margin: "0 0 8px 0",
          }}
        >
          <Tabs.TabPane key="Statistic" tab="Tổng quan">
            <Row gutter={[8, 8]} style={{ padding: "8px 8px 8px 8px" }}>
              <Col>
                <DatePicker
                  placeholder="Ngày bắt đầu"
                  value={overviewFromDate}
                  onChange={(e) => setOverviewFromDate(e)}
                  style={{ width: "100%" }}
                  disabledDate={(currentDate) => {
                    return currentDate && currentDate > dayjs().endOf("day");
                  }}
                  format="DD/MM/YYYY"
                />
              </Col>
              <Col>
                <Button onClick={onRefresh} type="primary">
                  Làm mới
                </Button>
              </Col>
              <Col span={24}>
                {size(overviewData) == 0 ? (
                  <Empty description="Không có dữ liệu" />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      flexWrap: "wrap",
                      gap: "8px 8px",
                    }}
                  >
                    {map(overviewData, (item) => {
                      return (
                        <div
                          className="w-100"
                          key={item.payload.device_type}
                          style={{
                            position: "relative",
                            borderRadius: 5,
                            flex: "0 0 calc(25% - 8px)",
                            boxSizing: "border-box" ,
                            height: "400px" 
                          }}
                        >
                          <Button
                            onClick={() => {
                              window.open(
                                `/system/admin/dashboard-device/${selectedStation.value}/${item.payload.device_type}`
                              );
                            }}
                            className="position-absolute text-primary"
                            style={{
                              right: 2,
                              top: 2,
                              zIndex: 1,
                              textDecoration: "underline",
                            }}
                            type="text"
                          >
                            Chi tiết
                          </Button>
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={item.chartData}
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
              </Col>
            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Hoạt động" key="Activity">
            <Row
              className="align-items-stretch"
              gutter={[8, 0]}
              style={{ padding: "0px 8px 8px 8px" }}
            >
              {false && (
                <>
                  <Col span={3}>
                    <div className="d-flex flex-column justify-content-between h-100">
                      <Card size="small" bordered={false}>
                        <div className="d-flex justify-content-between align-items-center">
                          <span>Đang kiểm tra</span>
                          <b
                            className="font-weight-bolder"
                            style={bHeaderStyle}
                          >
                            {
                              activityLogs.device_maintain_summary
                                ?.checking_total
                            }
                          </b>
                        </div>
                      </Card>
                      <Card size="small" bordered={false}>
                        <div className="d-flex justify-content-between align-items-center">
                          <span>Đã kiểm tra</span>
                          <b
                            style={bHeaderStyle}
                            className="text-primary font-weight-bolder"
                          >
                            {
                              activityLogs.device_maintain_summary
                                ?.checked_total
                            }
                          </b>
                        </div>
                      </Card>
                      <Card size="small" bordered={false}>
                        <div className="d-flex justify-content-between align-items-center">
                          <span>Xử lý chậm</span>
                          <b
                            style={bHeaderStyle}
                            className="text-danger font-weight-bolder"
                          >
                            {
                              activityLogs.device_maintain_summary
                                ?.past_due_total
                            }
                          </b>
                        </div>
                      </Card>
                    </div>
                  </Col>
                  <Col span={21}>
                    <Card
                      bordered={false}
                      className="h-100"
                      size="small"
                      headStyle={{
                        border: "none",
                        padding: "8px 24px 8px 24px",
                      }}
                      bodyStyle={{ padding: "0px 24px 24px 24px" }}
                      title={
                        <b style={{ fontSize: 18, fontWeight: 500 }}>
                          Chất lượng thiết bị
                        </b>
                      }
                    >
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr 1fr 1fr",
                          gridTemplateRows: "1fr 1fr",
                        }}
                      >
                        <div className="border-right divider">
                          <div>
                            <b style={bHeaderStyle}>
                              {activityLogs.device_quality_statistics
                                ?.online_total || 0}
                              TB
                            </b>
                            <span
                              className={classNames("ml-2", {
                                "text-danger":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_online_total <= 0,
                                "text-primary":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_online_total <= 0,
                              })}
                            >
                              {
                                activityLogs.device_quality_statistics
                                  ?.percentage_online_total
                              }
                              %
                            </span>
                          </div>
                          <div className="text-label">
                            Số lượng thiết bị online
                          </div>
                        </div>
                        <div
                          className="border-right divider"
                          style={{ marginLeft: 16 }}
                        >
                          <div>
                            <b style={bHeaderStyle}>
                              {activityLogs.device_quality_statistics
                                ?.online_total || 0}
                              TB
                            </b>
                            <span
                              className={classNames("ml-2", {
                                "text-danger":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_online_total <= 0,
                                "text-primary":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_online_total <= 0,
                              })}
                            >
                              {
                                activityLogs.device_quality_statistics
                                  ?.percentage_online_total
                              }
                              %
                            </span>
                          </div>
                          <div className="text-label">Thiết bị gặp sự cố</div>
                        </div>
                        <div
                          className="border-right divider"
                          style={{ marginLeft: 16 }}
                        >
                          <div>
                            <b style={bHeaderStyle}>
                              {activityLogs.device_quality_statistics?.power ||
                                0}{" "}
                              ĐH
                            </b>
                            <span
                              className={classNames("ml-2", {
                                "text-danger":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_power <= 0,
                                "text-primary":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_power <= 0,
                              })}
                            >
                              {
                                activityLogs.device_quality_statistics
                                  ?.percentage_power
                              }
                              %
                            </span>
                          </div>
                          <div className="text-label">Công suất</div>
                        </div>
                        <div className="" style={{ marginLeft: 16 }}>
                          <div>
                            <b style={bHeaderStyle}>
                              {activityLogs.device_quality_statistics
                                ?.active_time || 0}{" "}
                              h
                            </b>
                            <span
                              className={classNames("ml-2", {
                                "text-danger":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_active_time <= 0,
                                "text-primary":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_active_time <= 0,
                              })}
                            >
                              {
                                activityLogs.device_quality_statistics
                                  ?.percentage_active_time
                              }
                              %
                            </span>
                          </div>
                          <div className="text-label">Thời gian hoạt động</div>
                        </div>
                        <div className="border-right divider">
                          <div>
                            <b style={bHeaderStyle}>
                              {activityLogs.device_quality_statistics
                                ?.offline_total || 0}
                              TB
                            </b>
                            <span
                              className={classNames("ml-2", {
                                "text-danger":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_offline_total <= 0,
                                "text-primary":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_offline_total <= 0,
                              })}
                            >
                              {
                                activityLogs.device_quality_statistics
                                  ?.percentage_offline_total
                              }
                              %
                            </span>
                          </div>
                          <div className="text-label">Số thiết bị offline</div>
                        </div>
                        <div
                          className="border-right divider"
                          style={{ marginLeft: 16 }}
                        >
                          <div>
                            <b style={bHeaderStyle}>
                              {
                                activityLogs.device_quality_statistics
                                  ?.maintain_due_total
                              }
                              TB
                            </b>
                            <span
                              className={classNames("ml-2", {
                                "text-danger":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_maintain_due_total <= 0,
                                "text-primary":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_maintain_due_total <= 0,
                              })}
                            >
                              {
                                activityLogs.device_quality_statistics
                                  ?.percentage_maintain_due_total
                              }
                              %
                            </span>
                          </div>
                          <div className="text-label">Đến hạn bảo dưỡng</div>
                        </div>
                        <div
                          className="border-right divider"
                          style={{ marginLeft: 16 }}
                        >
                          <div>
                            <b style={bHeaderStyle}>
                              {activityLogs.device_quality_statistics?.employee}{" "}
                              KTV
                            </b>
                            <span
                              className={classNames("ml-2", {
                                "text-danger":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_employee <= 0,
                                "text-primary":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_employee <= 0,
                              })}
                            >
                              {
                                activityLogs.device_quality_statistics
                                  ?.percentage_employee
                              }
                              %
                            </span>
                          </div>
                          <div className="text-label">Số KTV trực</div>
                        </div>
                        <div style={{ marginLeft: 16 }}>
                          <div>
                            <b style={bHeaderStyle}>
                              {activityLogs.device_quality_statistics
                                ?.un_daily_checked || 0}
                              TB
                            </b>
                            <span
                              className={classNames("ml-2", {
                                "text-danger":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_un_daily_checked <= 0,
                                "text-primary":
                                  activityLogs.device_quality_statistics &&
                                  activityLogs.device_quality_statistics
                                    .percentage_un_daily_checked <= 0,
                              })}
                            >
                              {
                                activityLogs.device_quality_statistics
                                  ?.percentage_un_daily_checked
                              }
                              %
                            </span>
                          </div>
                          <div className="text-label">
                            Chưa kiểm tra hằng ngày
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </>
              )}
              <Col span={24}>
                <Form
                  form={form}
                  layout="vertical"
                  onValuesChange={(changedValue, values) => {
                    if (changedValue && has(changedValue, "task_type")) {
                      onValuesChange();
                      // getCheckListFilters(
                      //   selectedStation.value,
                      //   changedValue.task_type
                      // );
                    }
                  }}
                  style={{ width: "100%" }}
                  initialValues={{
                    username: query.get("username"),
                    shift_config_id: query.get("shift_id"),
                    task_type: "all",
                    status: "all",
                  }}
                >
                  <Form.Item hidden={true} name="station_id">
                    <Input />
                  </Form.Item>
                  <div>
                    <div
                      className="d-flex align-items-center mb-2"
                      style={{ fontSize: 18, fontWeight: 500 }}
                    >
                      Công việc xử lý ngày {dayjs().format("DD/MM/YYYY")}
                      <Button
                        className="ml-2"
                        type="text"
                        size="small"
                        onClick={onShowFilter}
                      >
                        <FilterOutlined
                          style={{
                            color: showFilter.hasFilter ? "#069255" : "#bdbdbd",
                          }}
                        />
                      </Button>
                    </div>
                    <div className="mb-2">{renderFilterTag()}</div>
                  </div>
                  <Card style={CARD_STYLE} size="small">
                    <Row justify="" align="middle">
                      {showFilter.show && (
                        <>
                          <Col span={24}>
                            <Row gutter={[8]} align="bottom">
                              <Col xs={12} md={3}>
                                <Form.Item
                                  name="device_type"
                                  label="Thiết bị"
                                  className="mb-0"
                                >
                                  <Select
                                    placeholder="Chọn thiết bị"
                                    allowClear
                                    options={(
                                      checklistFilters?.device_types || []
                                    ).map((i) => ({
                                      label: i.name,
                                      value: i.device_type,
                                    }))}
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={12} md={3}>
                                <Form.Item
                                  name="device_id"
                                  label="Mã thiết bị"
                                  className="mb-0"
                                >
                                  <Input
                                    placeholder="Mã thiết bị..."
                                    allowClear
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={12} md={3}>
                                <Form.Item
                                  name="username"
                                  label="KTV"
                                  className="mb-0"
                                >
                                  <Input
                                    placeholder="KTV..."
                                    allowClear
                                    disabled={
                                      query.get("username") ? true : false
                                    }
                                  />
                                </Form.Item>
                              </Col>

                              <Col xs={12} md={3}>
                                <Button onClick={onValuesChange} type="primary">
                                  Tìm kiếm
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                        </>
                      )}

                      <Col span={24} className="mt-3">
                        <Table
                          size="small"
                          columns={columns}
                          loading={isFetching}
                          dataSource={tableData.dataSource}
                          rowKey="task_id"
                          pagination={{
                            ...tableConfig.pagination,
                            total: tableData.total,
                          }}
                          onChange={onChangeTable}
                          scroll={{
                            x: "max-content",
                          }}
                          expandable={
                            isHasSubTask
                              ? {
                                  rowExpandable: (record) =>
                                    size(record.maintain_subtasks) > 0,
                                  expandedRowRender,
                                  defaultExpandedRowKeys: ["0"],
                                  expandIcon: ({
                                    expanded,
                                    onExpand,
                                    record,
                                  }) => {
                                    if (size(record.maintain_subtasks) === 0)
                                      return null;
                                    return expanded ? (
                                      <CaretDownOutlined
                                        onClick={() => onExpand(record)}
                                        style={{ color: "#069255" }}
                                      />
                                    ) : (
                                      <RightOutlined
                                        onClick={() => onExpand(record)}
                                        style={{ color: "#bdbdbd" }}
                                      />
                                    );
                                  },
                                }
                              : false
                          }
                        />
                      </Col>
                    </Row>
                  </Card>
                </Form>
              </Col>
              <Col span={24} className="mt-2" ref={offlineRef}>
                {isShowOffline && (
                  <Form
                    form={offlineDeviceForm}
                    layout="vertical"
                    style={{ width: "100%" }}
                    initialValues={{
                      device_type: null,
                    }}
                  >
                    <div>
                      <div
                        className="d-flex align-items-center mb-2"
                        style={{ fontSize: 18, fontWeight: 500 }}
                      >
                        Danh sách thiết bị Offline
                        {/* <Button
                          className="ml-2"
                          type="text"
                          size="small"
                          onClick={onShowFilterOffline}
                        >
                          <FilterOutlined
                            style={{
                              color: showFilterOffline.hasFilter
                                ? "#069255"
                                : "#bdbdbd",
                            }}
                          />
                        </Button> */}
                      </div>
                      <div className="mb-2">
                        {renderFilterOfflineDeviceTag()}
                      </div>
                    </div>
                    <Card style={CARD_STYLE} size="small">
                      <Row align="middle">
                        <Col span={24}>
                          <Table
                            size="small"
                            columns={offlineDeviceColumns}
                            dataSource={tableOfflineDeviceData.dataSource}
                            rowKey="id"
                            pagination={{
                              ...tableOfflineDeviceConfig.pagination,
                              total: tableOfflineDeviceData.total,
                            }}
                            onChange={onChangeOfflineDeviceTable}
                            scroll={{
                              x: "max-content",
                            }}
                          />
                        </Col>
                      </Row>
                    </Card>
                  </Form>
                )}
              </Col>
            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane key="Device" tab="Thiết bị">
            <Table
              size="small"
              bordered
              rowKey="label"
              columns={deviceColumns}
              dataSource={devices}
              pagination={false}
            />
          </Tabs.TabPane>
        </Tabs>
      ) : (
        <Empty description="Không có dữ liệu.Vui lòng chọn kho." />
      )}

      <Modal
        open={viewDeviceList.show}
        width="85%"
        footer={null}
        title={viewDeviceList.title}
        onCancel={onCancelDeviceModal}
      >
        <Form form={deviceForm} layout="vertical" style={{ width: "100%" }}>
          <Card style={CARD_STYLE} size="small">
            <Row justify="" align="bottom">
              {viewDeviceList.type === "CONVEYOR" && (
                <Col span={24}>
                  <Row gutter={[8]} align="bottom">
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="station_position"
                        label="Vị trí"
                        className="mb-0"
                      >
                        <Input placeholder="Vị trí" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="device_id"
                        label="Mã thiết bị"
                        className="mb-0"
                      >
                        <Input placeholder="Mã thiết bị" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="asset_code"
                        label="Mã tài sản"
                        className="mb-0"
                      >
                        <Input placeholder="Mã tài sản" allowClear />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button type="primary" onClick={searchDevice}>
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )}
              {viewDeviceList.type === "MODULE_SORTING" && (
                <Col span={24}>
                  <Row gutter={[8]} align="bottom">
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="device_id"
                        label="Mã thiết bị"
                        className="mb-0"
                      >
                        <Input placeholder="Mã thiết bị" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="asset_code"
                        label="Mã tài sản"
                        className="mb-0"
                      >
                        <Input placeholder="Mã tài sản" allowClear />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button type="primary" onClick={searchDevice}>
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )}
              {viewDeviceList.type === "TELESCOPIC" && (
                <Col span={24}>
                  <Row gutter={[8]} align="bottom">
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="device_id"
                        label="Mã thiết bị"
                        className="mb-0"
                      >
                        <Input placeholder="Mã thiết bị" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="asset_code"
                        label="Mã tài sản"
                        className="mb-0"
                      >
                        <Input placeholder="Mã tài sản" allowClear />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button type="primary" onClick={searchDevice}>
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )}
              {viewDeviceList.type === "BARRIER" && (
                <Col span={24}>
                  <Row gutter={[8]} align="bottom">
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="device_id"
                        label="Mã thiết bị"
                        className="mb-0"
                      >
                        <Input placeholder="Mã thiết bị" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="asset_code"
                        label="Mã tài sản"
                        className="mb-0"
                      >
                        <Input placeholder="Mã tài sản" allowClear />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button type="primary" onClick={searchDevice}>
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )}
              {viewDeviceList.type === "SCALE" && (
                <Col span={24}>
                  <Row gutter={[8]} align="bottom">
                    <Col xs={12} md={3}>
                      <Form.Item name="type" label="Phiên bản" className="mb-0">
                        <Input placeholder="Phiên bản" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="scale_status"
                        label="Trạng thái cân"
                        className="mb-0"
                      >
                        <Select
                          allowClear
                          size="default"
                          placeholder="Chọn trạng thái cân"
                          style={{ width: "100%" }}
                        >
                          {map(SCALE_STATUS, (scaleStatus) => (
                            <Select.Option
                              key={scaleStatus.value}
                              value={scaleStatus.value}
                            >
                              {scaleStatus.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="device_id"
                        label="Mã thiết bị"
                        className="mb-0"
                      >
                        <Input placeholder="Mã thiết bị" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="asset_code"
                        label="Mã tài sản"
                        className="mb-0"
                      >
                        <Input placeholder="Mã tài sản" allowClear />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button type="primary" onClick={searchDevice}>
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )}
              {viewDeviceList.type === "CROSSBELT" && (
                <Col span={24}>
                  <Row gutter={[8]} align="bottom">
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="device_id"
                        label="Mã thiết bị"
                        className="mb-0"
                      >
                        <Input placeholder="Mã thiết bị" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="asset_code"
                        label="Mã tài sản"
                        className="mb-0"
                      >
                        <Input placeholder="Mã tài sản" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="type"
                        label="Loại thiết bị"
                        className="mb-0"
                      >
                        <Select placeholder="Chọn loại thiết bị" allowClear>
                          {map(childDeviceTypes, (type) => (
                            <Select.Option key={type} value={type}>
                              {type}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button type="primary" onClick={searchDevice}>
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )}
              {viewDeviceList.type === "BOMBAY" && (
                <Col span={24}>
                  <Row gutter={[8]} align="bottom">
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="device_id"
                        label="Mã thiết bị"
                        className="mb-0"
                      >
                        <Input placeholder="Mã thiết bị" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="asset_code"
                        label="Mã tài sản"
                        className="mb-0"
                      >
                        <Input placeholder="Mã tài sản" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="type"
                        label="Loại thiết bị"
                        className="mb-0"
                      >
                        <Select placeholder="Chọn loại thiết bị" allowClear>
                          {map(childDeviceTypes, (type) => (
                            <Select.Option key={type} value={type}>
                              {type}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button type="primary" onClick={searchDevice}>
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )}
              {viewDeviceList.type === "TRACKER" && (
                <Col span={24}>
                  <Row gutter={[8]} align="bottom">
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="device_id"
                        label="Mã thiết bị"
                        className="mb-0"
                      >
                        <Input placeholder="Mã thiết bị" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="asset_code"
                        label="Mã tài sản"
                        className="mb-0"
                      >
                        <Input placeholder="Mã tài sản" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="status"
                        label="Trạng thái"
                        className="mb-0"
                      >
                        <Select placeholder="Chọn trạng thái" allowClear>
                          <Select.Option value="ACTIVE">
                            {WORKING_STATUS["ACTIVE"].text}
                          </Select.Option>
                          <Select.Option value="NO_GPS">
                            {WORKING_STATUS["NO_GPS"].text}
                          </Select.Option>
                          <Select.Option value="TEMPORARY_DOWN">
                            {WORKING_STATUS["TEMPORARY_DOWN"].text}
                          </Select.Option>
                          <Select.Option value="DOWN">
                            {WORKING_STATUS["DOWN"].text}
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button type="primary" onClick={searchDevice}>
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )}
              {viewDeviceList.type === "CAMERA_STATION" && (
                <Col span={24}>
                  <Row gutter={[8]} align="bottom">
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="device_id"
                        label="Mã thiết bị"
                        className="mb-0"
                      >
                        <Input placeholder="Mã thiết bị" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="asset_code"
                        label="Mã tài sản"
                        className="mb-0"
                      >
                        <Input placeholder="Mã tài sản" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="status"
                        label="Trạng thái"
                        className="mb-0"
                      >
                        <Select placeholder="Chọn trạng thái" allowClear>
                          {map(DVR_STATUS_FOR_FILTER, (item) => (
                            <Select.Option value={item.id} key={item.id}>
                              {item.name}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button type="primary" onClick={searchDevice}>
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )}
              {viewDeviceList.type === "PRINTER" && (
                <Col span={24}>
                  <Row gutter={[8]} align="bottom">
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="device_id"
                        label="Mã thiết bị"
                        className="mb-0"
                      >
                        <Input placeholder="Mã thiết bị" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="asset_code"
                        label="Mã tài sản"
                        className="mb-0"
                      >
                        <Input placeholder="Mã tài sản" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="status"
                        label="Trạng thái"
                        className="mb-0"
                      >
                        <Select placeholder="Chọn trạng thái" allowClear>
                          {map(DEVICE_STATUS, (printerStatus) => (
                            <Select.Option
                              key={printerStatus.value}
                              value={printerStatus.value}
                            >
                              {printerStatus.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button type="primary" onClick={searchDevice}>
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )}
              {viewDeviceList.type === "CABINET" && (
                <Col span={24}>
                  <Row gutter={[8]} align="bottom">
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="device_id"
                        label="Mã thiết bị"
                        className="mb-0"
                      >
                        <Input placeholder="Mã thiết bị" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="asset_code"
                        label="Mã tài sản"
                        className="mb-0"
                      >
                        <Input placeholder="Mã tài sản" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="status"
                        label="Trạng thái"
                        className="mb-0"
                      >
                        <Select placeholder="Chọn trạng thái" allowClear>
                          {map(DEVICE_STATUS, (printerStatus) => (
                            <Select.Option
                              key={printerStatus.value}
                              value={printerStatus.value}
                            >
                              {printerStatus.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button type="primary" onClick={searchDevice}>
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )}
              {viewDeviceList.type === "CAMERA_TRUCK" && (
                <Col span={24}>
                  <Row gutter={[8]} align="bottom">
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="device_id"
                        label="Mã thiết bị"
                        className="mb-0"
                      >
                        <Input placeholder="Mã thiết bị" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="asset_code"
                        label="Mã tài sản"
                        className="mb-0"
                      >
                        <Input placeholder="Mã tài sản" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="status"
                        label="Trạng thái"
                        className="mb-0"
                      >
                        <Select placeholder="Chọn trạng thái" allowClear>
                          {map(DEVICE_STATUS, (printerStatus) => (
                            <Select.Option
                              key={printerStatus.value}
                              value={printerStatus.value}
                            >
                              {printerStatus.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button type="primary" onClick={searchDevice}>
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )}
              {viewDeviceList.type === "WHEEL_SORTER" && (
                <Col span={24}>
                  <Row gutter={[8]} align="bottom">
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="device_id"
                        label="Mã thiết bị"
                        className="mb-0"
                      >
                        <Input placeholder="Mã thiết bị" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="asset_code"
                        label="Mã tài sản"
                        className="mb-0"
                      >
                        <Input placeholder="Mã tài sản" allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="type_code"
                        label="Loại thiết bị"
                        className="mb-0"
                      >
                        <Select placeholder="Chọn loại thiết bị" allowClear>
                          {map(childDeviceTypes, (type) => (
                            <Select.Option key={type} value={type}>
                              {type}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Item
                        name="station_position"
                        label="Vị trí"
                        className="mb-0"
                      >
                        <Input placeholder="Vị trí" allowClear />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button type="primary" onClick={searchDevice}>
                        Tìm kiếm
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )}

              <Col span={24} className="mt-3">
                <Table
                  size="small"
                  columns={legoColumns}
                  dataSource={tableDeviceData.dataSource}
                  loading={fetchingDevice}
                  rowKey="device_id"
                  pagination={{
                    ...tableDeviceConfig.pagination,
                    total: tableDeviceData.total,
                  }}
                  onChange={onChangeDeviceTable}
                  scroll={{
                    x: "max-content",
                  }}
                  expandable={{
                    expandedRowRender: deviceRowRender,
                    defaultExpandedRowKeys: ["0"],
                    onExpand: onDeviceTableExpand,
                    expandIcon:
                      viewDeviceList.type === "MODULE_SORTING" ||
                      viewDeviceList.type === "SCALE"
                        ? ({ expanded, onExpand, record }) => {
                            return expanded ? (
                              <CaretDownOutlined
                                onClick={() => onExpand(record)}
                                style={{ color: "#069255" }}
                              />
                            ) : (
                              <RightOutlined
                                onClick={() => onExpand(record)}
                                style={{ color: "#bdbdbd" }}
                              />
                            );
                          }
                        : undefined,
                  }}
                />
              </Col>
            </Row>
          </Card>
        </Form>
      </Modal>

      <ProfileDevicesModal
        config={profileModal}
        _handleToggleModal={() => {
          setProfileModal((prev) => ({
            ...prev,
            visible: false,
            dataSource: {},
          }));
        }}
      />
    </Card>
  );
}

// const ActivityTimeline = ({
//   checklistStatistic,
//   setActivityLogs,
//   checklistFilters,
// }) => {
//   const onShowChild = (timeLineIndex) => {
//     setActivityLogs((prev) => {
//       let next = { ...prev };
//       next.to_do_checklist_statistic[timeLineIndex].isOpen = !next
//         .to_do_checklist_statistic[timeLineIndex].isOpen;
//       return next;
//     });
//   };
//   return (
//     <Timeline>
//       {map(checklistStatistic, (timeline, timeLineIndex) => {
//         let countUnFinshedTask = filter(
//           timeline.maintain_tasks,
//           (x) => x.status != "DONE"
//         );
//         let isAllFinish =
//           size(countUnFinshedTask) === size(timeline.maintain_tasks);
//         return (
//           <Timeline.Item
//             color={isAllFinish ? "#069255" : "#F64E60"}
//             key={timeline.title}
//             label={dayjs(timeline.created_time).format("HH:mm")}
//           >
//             <div
//               className="d-flex flex-column"
//               style={{
//                 padding: "12px 12px",
//                 background: "#fff",
//                 borderRadius: 8,
//               }}
//             >
//               <div
//                 style={{ padding: "8px 12px" }}
//                 className="d-flex justify-content-between"
//               >
//                 <span style={{ fontWeight: 500 }}>{timeline.title}</span>
//                 <div className="d-flex">
//                   <span className="text-danger">
//                     {size(countUnFinshedTask)}/{size(timeline.maintain_tasks)}{" "}
//                     chưa xử lý
//                   </span>
//                   <div
//                     style={{ width: 25, height: 25, cursor: "pointer" }}
//                     className="ml-2 d-flex justify-content-center align-items-center"
//                     onClick={() => onShowChild(timeLineIndex)}
//                   >
//                     {timeline.isOpen ? (
//                       <svg
//                         width="13"
//                         height="13"
//                         viewBox="0 0 13 13"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <rect
//                           width="7.29009"
//                           height="0.829758"
//                           rx="0.414879"
//                           transform="matrix(0.698953 0.715168 -0.742638 0.669694 6.78809 3.33301)"
//                           fill="#5C5C5C"
//                           stroke="#5C5C5C"
//                           strokeWidth="0.2"
//                         />
//                         <rect
//                           width="7.36561"
//                           height="0.796691"
//                           rx="0.398346"
//                           transform="matrix(-0.710399 0.703799 -0.731775 -0.681546 7.31543 3.91895)"
//                           fill="#5C5C5C"
//                           stroke="#5C5C5C"
//                           strokeWidth="0.2"
//                         />
//                       </svg>
//                     ) : (
//                       <svg
//                         width="13"
//                         height="13"
//                         viewBox="0 0 13 13"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <rect
//                           width="7.29009"
//                           height="0.829758"
//                           rx="0.414879"
//                           transform="matrix(-0.698953 -0.715168 0.742638 -0.669694 6.5957 9.43652)"
//                           fill="#5C5C5C"
//                           stroke="#5C5C5C"
//                           strokeWidth="0.2"
//                         />
//                         <rect
//                           width="7.36561"
//                           height="0.796691"
//                           rx="0.398346"
//                           transform="matrix(0.710399 -0.703799 0.731775 0.681546 6.06836 8.85059)"
//                           fill="#5C5C5C"
//                           stroke="#5C5C5C"
//                           strokeWidth="0.2"
//                         />
//                       </svg>
//                     )}
//                   </div>
//                 </div>
//               </div>
//               {timeline.isOpen &&
//                 map(timeline.maintain_tasks, (task, index) => {
//                   let statusName = get(
//                     checklistFilters,
//                     ["task_status", task.status],
//                     "N/a"
//                   );
//                   let isFinished = task.status === "DONE";
//                   return (
//                     <div
//                       key={task.task_id}
//                       style={{
//                         display: "grid",
//                         gridTemplateColumns: "1fr 1fr 150px",
//                         padding: "8px 12px",
//                         background: index % 2 === 0 ? "#F8F8F8" : "#fff",
//                       }}
//                     >
//                       <div className="d-flex align-items-center">
//                         {task.username || "N/a"} | {task.task_name}
//                       </div>
//                       <div
//                         className={classNames("d-flex align-items-center", {
//                           "text-primary": isFinished,
//                           "text-danger": !isFinished,
//                         })}
//                       >
//                         {statusName}
//                       </div>
//                       <div className="text-right">
//                         {isFinished ? (
//                           <span className="text-primary">Hoàn thành</span>
//                         ) : (
//                           <div className="btn btn-primary">Thao tác</div>
//                         )}
//                       </div>
//                     </div>
//                   );
//                 })}
//             </div>
//           </Timeline.Item>
//         );
//       })}
//     </Timeline>
//   );
// };

export default CapacitoringDataPage;
